import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-itemaddsushint",
  "use": "icon-itemaddsushint-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-itemaddsushint\">\r\n  <defs>\r\n    <style>\r\n      #icon-itemaddsushint .cls-1 {\r\n        fill: #40a9ff;\r\n      }\r\n\r\n      #icon-itemaddsushint .cls-2 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <circle id=\"icon-itemaddsushint_椭圆_987\" data-name=\"椭圆 987\" class=\"cls-1\" cx=\"12\" cy=\"12\" r=\"12\" />\r\n  <path id=\"icon-itemaddsushint_对\" class=\"cls-2\" d=\"M558.413,377a0.909,0.909,0,0,0,.63-0.269l7.705-8.214a0.929,0.929,0,0,0-.014-1.284,0.841,0.841,0,0,0-1.232.015l-7.089,7.557-3.925-4.092a0.839,0.839,0,0,0-1.232,0,0.93,0.93,0,0,0,0,1.284l4.541,4.734a0.8,0.8,0,0,0,.616.269h0Zm0,0\" transform=\"translate(-548 -360)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/itemaddsushint.svg
// module id = wuzn
// module chunks = 127